import { ThemeProperties } from '../core';

export interface CommonTheme {
	focusColor: string;
}
export const theme = new ThemeProperties('common');
